import React, { useEffect, useState } from "react";
import styles from './DrawRecord.module.scss';
import Library from "../../../../library";
import Services from "../../../../services";
import no_data from '../../../../images/noCollection.png'
import { PullToRefresh, InfiniteScroll, List, Empty, Toast } from 'antd-mobile'
import Header from "components/header";
const { JsBridge } = Library;

export const DrawRecord = () => {
  const [pageNum, setPageNum] = useState(1)
  const [dataList, setDataList] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [hasMore, setHasMore] = useState(false)
  useEffect(() => {
    loadData();
  }, []);

  let loadData = async () => {
    setPageNum(1)
    setIsLoading(true)
    const res = await Services('MainPage', { code: '300021' }, {
      activityCode: "NY2023",
      // userCode: "13817952661",
      pageNum: `1`,
      pageSize: "10"
    });
    setIsLoading(false)
    if (!!res && res?.status == 1 && !!res?.data) {
      let { list = [] } = res.data
      setDataList(list)
      setHasMore(list.length >= 10)
    }
  }
  let loadMore = async () => {
    const res = await Services('MainPage', { code: '300021' }, {
      activityCode: "NY2023",
      // userCode: "13817952661",
      pageNum: `${pageNum + 1}`,
      pageSize: "10"
    });
    if (!!res && res?.status == 1 && !!res?.data) {
      let { list = [] } = res.data
      setDataList([...dataList, ...list])
      setHasMore(list.length >= 10)
      setPageNum(pageNum + 1)
    }
  }

  return (
    <div className={styles.root}>
      <Header midText={`抽奖记录`} bgColor={'#fff'} />
      <div className={styles.container}>
        {!isLoading && (!dataList || dataList?.length == 0) &&
          <Empty style={{ width: "100%", paddingTop: ' 30%' }} image={<img src={no_data} />} description="暂无数据" />
        }
        {!!dataList && !!dataList.length &&
          <PullToRefresh onRefresh={loadData}>
            <div className={styles.listContainer}>
              {dataList?.map((item, index) => (
                <div className={styles.itemContainer} key={`${index} - ${JSON.stringify(item)}`}>
                  <div className={styles.itemLeft}>
                    <div className={styles.itemTop}>
                      <div className={styles.itemTopTitle}>
                        {`${item?.prizeName}`}
                      </div>
                    </div>
                    <div className={styles.itemTime}>
                      {`${item?.createTime}`}
                    </div>
                  </div >
                  {item?.prizeType == '3' &&
                    <div className={styles.itemAddressBtn}>
                      <div className={styles.itemAddressBtnTitle} onClick={() => {
                        JsBridge.push('CustomWeb', { uri: window.location.origin + '/front/activities/carnival/fillAddress' + `?id=${item?.id}` });
                        JsBridge.addListener().then(() => { loadData() })
                      }}>
                        {!!item?.deliveryAddressId ? `修改收货地址` : `填写地址领取奖品`}
                      </div>
                    </div>
                  }
                </div >
              ))}
            </div>
            {!isLoading &&
              <InfiniteScroll loadMore={loadMore} hasMore={hasMore} />
            }
          </PullToRefresh>
        }
      </div>
    </div>
  )
}